import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import withSingleFieldValidation from '../../hocs/withSingleFieldValidation';
import ErgoInputText from '../../components/ErgoInputText';

const ShortText = ({
  localePath,
  getValidationProps,
}, { t }) => (
  <div className="esc_grid">
    <div className="esc_grid__wrapper">
      <div className="esc_col esc_col-12">
        <ErgoInputText
          {...getValidationProps()}
          description={t(`${localePath}.description`)}
          placeholder={t(`${localePath}.placeholder`)}
        />
      </div>
    </div>
  </div>
);

ShortText.propTypes = {
  localePath: PropTypes.string,
  getValidationProps: PropTypes.func,
};

ShortText.defaultProps = {
  localePath: '',
  getValidationProps: () => {},
};

ShortText.contextTypes = {
  t: PropTypes.func,
};

export { ShortText as ShortTextPlain };
export default compose(
  withSingleFieldValidation,
)(ShortText);
